function isOwnerProfile(profile) {
  return Boolean(profile?.isOwner || profile?.is_owner);
}

function findBranch(profile, branches, branchId) {
  const fromBranches = branches?.find?.((branch) => branch.id === branchId);
  if (fromBranches) return fromBranches;
  return profile?.branches?.find?.((branch) => branch.id === branchId) ?? null;
}

export function getCrmBranchPermissionSet(profile, branches, branchId) {
  if (isOwnerProfile(profile)) return null;
  const branch = findBranch(profile, branches, branchId);
  return new Set(branch?.permissions ?? []);
}

export function hasCrmPermission(profile, branches, branchId, permissionKey) {
  if (isOwnerProfile(profile)) return true;
  if (!permissionKey) return false;
  const permissions = getCrmBranchPermissionSet(profile, branches, branchId);
  return permissions?.has(permissionKey) ?? false;
}

export function hasAnyCrmPermission(profile, branches, branchId, permissionKeys) {
  if (isOwnerProfile(profile)) return true;
  const permissions = getCrmBranchPermissionSet(profile, branches, branchId);
  if (!permissions) return false;
  return permissionKeys.some((permissionKey) => permissions.has(permissionKey));
}

export function canManageCrmAccess(profile) {
  return isOwnerProfile(profile);
}
